exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bssledio-wrapper{padding:10px;background-color:#63687e}.bssledio-title-wrapper{float:left;color:#fff;font-weight:bolder;text-transform:uppercase;width:70px}.bssledio{float:left;border:thin solid gray;width:20px;height:20px;margin-left:5px}.bssledio-on{box-shadow:rgba(0,0,0,.2) 0 -1px 2px 1px,inset #304701 0 -1px 4px,#89ff00 0 2px 7px}.bssledio-caption{float:left;width:20px;height:20px;margin-left:5px;padding:1px}.bssledio-testo-wrapper{margin-left:70px}", ""]);

// exports
